import { Box, Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { customEvent, getPrimeUrl } from "goi_common";
import { baseColors, BaseButton, BaseStack } from "goi_common/src/design-system";
import { useEffect } from "react";
import {
  PRIME_EXIT_PATH,
  SANGJO_LANDING_EVENT_PATH,
  SangjoLandingTrigger,
} from "./sangjoLandingData";
import { GraphicIcon } from "./SangjoLandingUI";

/**
 * 상조 랜딩 뒤로가기 이탈방지 모달 — 100원 상조(고이프라임) 안내.
 * handoff 는 바텀시트지만 기획 요청으로 모달.
 * 크기는 같은 /match/request 의 MubinsoLeadModal 과 동일(minW 320, Chakra 기본 maxW, r20, p 28/24/24).
 * 딤 클릭으로 닫지 않는다(둘 중 하나를 골라야 이동이 진행된다).
 */
export default function SangjoLandingExitModal({
  isOpen,
  onLeave,
}: {
  isOpen: boolean;
  onLeave: () => void;
}) {
  const fireEvent = (trigger_and_target: SangjoLandingTrigger) =>
    customEvent({ newGtm: { path: SANGJO_LANDING_EVENT_PATH, trigger_and_target } });

  useEffect(() => {
    if (isOpen) fireEvent("exit_mdl_view");
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onLeave}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
      useInert={false}
      autoFocus={false}
    >
      <ModalOverlay />
      <ModalContent minWidth="320px" backgroundColor={baseColors.white} borderRadius="20px">
        <ModalBody padding="28px 24px 24px">
          <BaseStack width="100%">
            <Box className="body_2_normal_m" color={baseColors.primary_orange}>
              미리 준비하는 상조를 찾으시나요?
            </Box>
            <Box className="headline_1_sb" color={baseColors.label_normal} pt="8px">
              당장 장례가 필요한 게 아니라면,
              <br />
              100원 상조도 알아보세요.
            </Box>
            <Box className="body_3_reading_r" color={baseColors.label_assistive_1} pt="8px">
              매달 100원으로 미리 가입하고, 필요할 때 이용할 수 있는 선불제 상조예요.
            </Box>

            <Box width="100%" pt="20px">
              <BaseStack
                direction="horizontal"
                alignItems="center"
                spacing={14}
                p="16px"
                borderRadius="12px"
                bg={baseColors.background_accent_1}
              >
                <GraphicIcon name="100won" size={48} />
                <Box minWidth={0}>
                  <Box className="body_1_normal_sb" color={baseColors.label_normal}>
                    고이 100원 상조
                  </Box>
                  <Box className="caption_1_r" color={baseColors.label_assistive_1} pt="2px">
                    미리 가입하고 준비하는 선불제 상조
                  </Box>
                </Box>
              </BaseStack>
            </Box>

            <BaseStack width="100%" spacing={4} alignItems="center" pt="20px">
              <BaseButton
                type="primary"
                size="large"
                onClick={() => {
                  fireEvent("exit_mdl_prime");
                  window.location.href = getPrimeUrl(PRIME_EXIT_PATH);
                }}
              >
                <Box className="body_1_normal_m">100원 상조 알아보기</Box>
              </BaseButton>
              <Box
                as="button"
                py="8px"
                cursor="pointer"
                className="label_1_m"
                color={baseColors.label_assistive_1}
                onClick={() => {
                  fireEvent("exit_mdl_leave");
                  onLeave();
                }}
              >
                괜찮아요, 페이지 나가기
              </Box>
            </BaseStack>
          </BaseStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
